import React from 'react';
import "./Support.scss"
export default function Support() {
    const [result, setResult] = React.useState("");

    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const form = event.currentTarget;
      setResult("Sending....");
      const formData = new FormData(form);

      formData.append("access_key", "0824ffe6-4a63-43d6-a238-fb00e13e7df1");

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully");
        form.reset();
      } else {
        console.log("Error", data);
        setResult(data.message);
      }
    };

    return (
      <div className="support-page">
        {result && <div className="form-result">{result}</div>}

        <div className="support-page-header">
            <h1>Support</h1>
            <p>For questions or feedback please fill out the form below.</p>
        </div>

        <form onSubmit={onSubmit}>

            <div className="form-group">
                <label>Name</label>
          <input type="text" name="name" required/>
          </div>

            <div className="form-group">
          <label>Email</label>
          <input type="email" name="email" required/>
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea name="message" required></textarea>
          </div>

          <button type="submit" className="btn btn-primary">Submit Form</button>

        </form>



      </div>
    );
  }